import { render, staticRenderFns } from "./AdminSettingsSharing.vue?vue&type=template&id=67089252"
import script from "./AdminSettingsSharing.vue?vue&type=script&lang=ts"
export * from "./AdminSettingsSharing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports